import { ChronoUnit, LocalDate } from '@js-joda/core';

import { MAX_LEAVE_DAYS } from '../../common.constants';
import { MedicalLeaveDateRange } from '../../common.types';

const getDatesDaysDiff = (startDate: LocalDate, endDate: LocalDate): number =>
   startDate.until(endDate, ChronoUnit.DAYS);

const findStartDate = (dateRange: MedicalLeaveDateRange | null): LocalDate | null =>
   dateRange && dateRange.hasLowerBound() ? dateRange.lowerEndpoint() : null;

const findEndDate = (dateRange: MedicalLeaveDateRange | null): LocalDate | null =>
   dateRange && dateRange.hasUpperBound() ? dateRange.upperEndpoint() : null;

const isDateRangeClosed = (dateRange: MedicalLeaveDateRange | null): boolean =>
   dateRange ? dateRange.hasLowerBound() && dateRange.hasUpperBound() : false;

const areDatesAboveMaxLeaveDays = (startDate: LocalDate, endDate: LocalDate): boolean =>
   getDatesDaysDiff(startDate, endDate) >= MAX_LEAVE_DAYS;

export { areDatesAboveMaxLeaveDays, findStartDate, findEndDate, getDatesDaysDiff, isDateRangeClosed };
